import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, paginatorTemplate, onPageChange, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { formatDateTH } from "../../../utilities/DateUtil";

export default function P216List({ dataTable, goPage }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (rowData) => goPage({ go: "EDIT", data: rowData });
    const actionBtn = (act) => goPage({ go: act });

    const headerAddLabel = <span className="hidden-responsive">เพิ่มใบแจ้งเตือนใหม่</span>;

    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive span-responsive " label={headerAddLabel} icon="pi pi-plus" onClick={() => actionBtn("NEW")} />
        </div>
    );

    const dateColumn = (rowData, isTime, checkColumn, titleShow) => {
        let date = { ...rowData };
        let datevalue = date[`${checkColumn}`];

        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {datevalue && datevalue !== "" ? formatDateTH(datevalue, isTime) : "-"}
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    header={header}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                >
                    <Column field="warningNo" header="แจ้งเตือนครั้งที่" body={(e) => normalColumn(e, "warningNo", "แจ้งเตือนครั้งที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="warningDate" header="วันที่แจ้ง" body={(e) => dateColumn(e, false, "warningDate", "วันที่สั่ง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="warningTopic" header="เรื่อง" body={(e) => normalColumn(e, "warningTopic", "เรื่อง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="warningLetterNo" header="เลขที่หนังสือแจ้ง" body={(e) => normalColumn(e, "warningLetterNo", "เลขที่หนังสือแจ้ง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="issuerName" header="ผู้แจ้ง" body={(e) => normalColumn(e, "issuerName", "ผู้แจ้ง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="updateUserName" header="ผู้บันทึกแก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้บันทึกแก้ไข")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="updateDt" header="วันที่-เวลาที่แก้ไข" body={(e) => normalColumn(e, "updateDt", "วันที่-เวลาที่แก้ไข")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="แก้ไข" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
